import { RowNode } from '@ag-grid-community/core';
import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import { Key } from 'w3c-keys';
import { Icon, IconColor, IconSize } from '../../../../icon';
import { Link } from '../../../../link/link';
import { isHTML, SafeHTML } from '../../../../safe-html/safe-html';
import styles from './details-cell.module.scss';
export const DetailsCell = ({ data, node, colDef, context, children, url, iconTooltip, secondIconTooltip, subtextClassName, showTitleAsLink = true, detailsCellContainerClassName, }) => {
    const [isHovering, setIsHovering] = useState(false);
    const showRow = () => setIsHovering(true);
    const hideRow = () => setIsHovering(false);
    useEffect(() => {
        node.addEventListener(RowNode.EVENT_MOUSE_ENTER, showRow);
        node.addEventListener(RowNode.EVENT_MOUSE_LEAVE, hideRow);
        return () => {
            node.removeEventListener(RowNode.EVENT_MOUSE_ENTER, showRow);
            node.removeEventListener(RowNode.EVENT_MOUSE_LEAVE, hideRow);
        };
    }, [node]);
    const values = (colDef === null || colDef === void 0 ? void 0 : colDef.colId) && data[colDef.colId] ? data[colDef.colId] : {};
    const onRowNameClicked = (e) => {
        if (e.metaKey || e.ctrlKey) {
            // eslint-disable-next-line security/detect-non-literal-fs-filename
            window.open(url, '_blank', 'noopener');
            e.preventDefault();
            return;
        }
        if (context.detailsAction) {
            context.detailsAction(data);
        }
        e.preventDefault();
    };
    const onRowNameSelected = (e) => {
        if (e.key === Key.Enter) {
            onRowNameClicked(e);
        }
    };
    const showTitle = values.title || children;
    const safeHTMLTitle = (React.createElement(SafeHTML, { html: values.title, className: cx(styles.titleHtmlSupport, {
            [styles.plainTextTitle]: !isHTML(values.title),
        }) }));
    return (React.createElement("div", { className: cx(styles.detailsCellContainer, detailsCellContainerClassName, { [styles.detailsCellContainerDisabled]: values.disabled }), "data-testid": "value-cell" },
        values.icon && (React.createElement("div", { "data-tooltip-content": iconTooltip },
            React.createElement(Icon, { className: cx(styles.icon, {
                    [values.iconClassName]: values.iconClassName,
                }), id: values.icon, color: values.iconColor || IconColor.TEXT_COLOR, size: values.iconSize || IconSize.MEDIUM }))),
        values.secondIcon && (React.createElement("div", { "data-tooltip-content": secondIconTooltip || iconTooltip },
            React.createElement(Icon, { className: styles.secondIcon, id: values.secondIcon, size: values.secondIconSize || IconSize.MEDIUM }))),
        React.createElement("div", { className: styles.detailsCellBodyContainer },
            showTitle && (React.createElement("div", { className: styles.detailsCellTextContainer, "data-tooltip-content": values.title },
                showTitleAsLink && (React.createElement(Link, { className: styles.title, href: url, onClick: onRowNameClicked, onKeyPress: onRowNameSelected }, safeHTMLTitle)),
                !showTitleAsLink && (React.createElement("span", { className: styles.titleWithoutLink }, safeHTMLTitle)),
                children && children(values, isHovering))),
            React.createElement("div", { className: styles.detailsCellTextContainer },
                values.textIcon && (React.createElement(Icon, { className: styles.icon, id: values.textIcon, color: IconColor.TEXT_COLOR, size: IconSize.MEDIUM })),
                values.text && (React.createElement("span", { className: cx(styles.text, subtextClassName) }, values.text))))));
};
//# sourceMappingURL=details-cell.js.map